<script setup lang="ts">
import Slider from '@/widgets/slider/index';
import { useMainSlider } from '../composable/useMainSlider';

const { banners } = await useMainSlider();
</script>

<template>
  <Slider
    :slides="banners"
    :items-to-show="1"
    effect="fade"
    is-show-navigation
    is-show-pagination
    autoplay
    loop
    :gap="20"
    class="banner-slider"
  >
    <template #slide="{ slide }">
      <a class="banner-slider__slide" :href="slide?.link" target="_blank">
        <NuxtImg
          class="banner-slider__image"
          :src="slide?.image"
          alt="banner"
          sizes="100vw"
          preload
        />
      </a>
    </template>
  </Slider>
</template>

<style lang="less">
.banner-slider {
  .container-d();

  position: relative;

  &__slide {
    display: block;
    height: auto;
    border-radius: @size-x4;
  }

  &__image {
    width: 100%;
    height: 100%;
    border-radius: @size-x4;
    object-fit: cover;
  }

  :deep(.embla__viewport) {
    border-radius: 12px;
  }
}
</style>
